// extracted by mini-css-extract-plugin
export default {"stakeContainer":"TvTpt","stakeItem":"n2678","smallContent":"sxs_K","innerLineStake":"Uhf7j"};